import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '@ui/dialog-v2/dialog.tokens';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PushService } from '@core/push/push.service';
import { PushCodeModel } from '@core/push/push-code.model';
import { ButtonModule } from '@ui/form/button/button.module';
import { DialogActions } from '@ui/dialog-v2/dialog-actions/dialog-actions';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'popup-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    imports: [
        ButtonModule,
        DialogActions,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class ConfirmDialogComponent implements OnDestroy {
    readonly #push: PushService = inject(PushService);
    readonly #data: DialogData = inject(MAT_DIALOG_DATA);
    readonly #dialogRef: MatDialogRef<ConfirmDialogComponent> = inject(MatDialogRef);

    readonly pending$: Observable<boolean> | undefined = this.#data.params?.pending$;
    private readonly destroy$: Subject<unknown> = new Subject<unknown>();

    public handlerClickConfirm(): void {
        this.#data.params
            .confirmFunction()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.#push.success(PushCodeModel.SuccessDelete);
                this.#dialogRef.close();
            });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
